import { FormattedMessage } from "react-intl"

class Transporter extends React.Component {
  render() {
    const {
      id,
      name,
      sku,
      numBoxes,
      numBags,
      count,
      image_url,
      product_link,
      type,
    } = this.props.transporter
    const displayNumBags = numBags !== undefined
    const { containerType } = this.props

    const transporterType =
      type === "bags" ? (
        <FormattedMessage id="togo.search_results.options.gobag" />
      ) : (
        <FormattedMessage id="togo.search_results.options.gobox" />
      )

    const formattedContainerType =
      containerType === "foodPan" ? (
        <FormattedMessage id="togo.search_results.options.foodpan" />
      ) : (
        <FormattedMessage id="togo.search_results.options.container" />
      )

    const transporterObjectName = type === "bags" ? "GoBag" : "GoBox"

    return (
      <li className="no-bullet">
        <div className="row">
          <div className="col-sm-3 col-xs-5">
            <img src={image_url} className="img-responsive" />
          </div>
          <div className="col-sm-9 col-xs-7">
            <div className="go-sku">{sku}</div>
            <p>
              <strong>{name}</strong>
              <br />
              <FormattedMessage
                id="togo.search_results.hold_capacity_message"
                values={{ transporterType, formattedContainerType, numBoxes }}
              />
              {displayNumBags && (
                <span>
                  {" "}
                  <FormattedMessage
                    id="togo.search_results.containers_needed_count_message"
                    values={{
                      transporterType,
                      formattedContainerType,
                      numBags,
                      count,
                    }}
                  />
                </span>
              )}
            </p>
            {numBags && (
              <div className="num-boxes">
                <img src={image_url} className="img-responsive" /> x {numBags}
              </div>
            )}
            <a href={product_link} style={{ color: "black" }}>
              <button className="btn-product">
                <FormattedMessage id="togo.search_results.actions.product_page" />
              </button>
            </a>
            <a
              href={`/quote_requests/basic_requests/new?selections%5B${transporterObjectName}%5D=${id}`}
              style={{ color: "black" }}
            >
              <button className="btn-product">
                <FormattedMessage id="togo.search_results.actions.quote_request" />
              </button>
            </a>
          </div>
        </div>
      </li>
    )
  }
}

export default Transporter
